import * as types from './ActionTypes';

export const addToast = (payload) => {
  return {
    type: types.ADD_TOAST,
    payload: payload
  };
};

export const dismissToast = (payload) => {
  return {
    type: types.DISMISS_TOAST,
    payload: payload
  };
};



// WEBPACK FOOTER //
// ./src/actions/toast.action.js